function recordIdToParentConstraint(recordId: string): string {
  const splitted = recordId.split(',');
  if (splitted.length < 2) {
    return splitted[0];
  }

  const parentConstraints: string[] = [];
  for (let i = 0; i < splitted.length; i += 2) {
    const key = splitted[i];
    const value = splitted[i + 1];
    parentConstraints.push(`${key}=${value}`);
  }

  return parentConstraints.join(',');
}

function parentConstraintToRecordId(parentConstraint: string): string {
  return parentConstraint.replaceAll('=', ',');
}

const DataStoreUtils = {
  recordIdToParentConstraint,
  parentConstraintToRecordId,
} as const;

export { DataStoreUtils };
